module.exports = __webpack_public_path__ + "static/media/kaomoji3.6ce31021.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/img/project/kaomoji/kaomoji3.png
// module id = 364
// module chunks = 0